// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2wh7V","signatureButtonsRight":"ModalSign_signatureButtonsRight__8DXZ7"};